export default __webpack_public_path__ + "static/media/06AW4SEP66.56d2cfce.jpg";